import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { Tables } from "@/integrations/supabase/types";

type Payment = Tables<"payments">;

interface RecentActivityProps {
  payments: Payment[];
}

const RecentActivity = ({ payments }: RecentActivityProps) => {
  return (
    <Card className="flex flex-col overflow-hidden">
      <CardHeader className="p-3 flex-shrink-0">
        <CardTitle className="text-xl">Actividad reciente</CardTitle>
      </CardHeader>
      <CardContent className="p-3 flex-grow min-h-0 overflow-auto">
        <div className="space-y-2">
          {payments.slice(0, 3).map((payment) => (
            <div key={payment.id} className="flex items-center justify-between p-3 rounded-lg bg-muted/50">
              <div>
                <p className="font-medium">{payment.description || 'Payment'}</p>
                <p className="text-sm text-muted-foreground">Pending payment</p>
              </div>
              <div className="text-right">
                <p className="font-medium">${Number(payment.amount).toLocaleString()}</p>
                <p className="text-sm text-muted-foreground">
                  {format(new Date(payment.payment_date), 'MMM d', { locale: es })}
                </p>
              </div>
            </div>
          ))}
          {payments.length === 0 && (
            <p className="text-center text-muted-foreground">Hay pagos pendientes</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default RecentActivity;